import { render, staticRenderFns } from "./tit-quarternary.vue?vue&type=template&id=02bb8230&scoped=true&"
import script from "./tit-quarternary.vue?vue&type=script&lang=js&"
export * from "./tit-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb8230",
  null
  
)

export default component.exports